import { useEffect, useState } from 'react';

// Service
import BillingService from '../../services/billingService';

//Hooks
import useUser from '../user/useUser';

// Models
import { utils } from '../../utils/utils';

const useInvoiceSummary = () => {
    const { branch, pv } = useUser();
    const [loading, setLoading] = useState(false);
    const [filters, setFilters] = useState({
        from: utils.getDateNow(),
        to: utils.getDateNow(),
        billingCode: pv?.billingCode,
    });
    const [invoiceSummary, setInvoiceSummary] = useState([]);

    useEffect(() => {
        const mapInvoiceSummaryItems = (res) => ([...res.vouchers, {
            type: 'Total',
            totalAmount: res.totalAmount,
            quantity: res.quantity
        }]);

        const getInvoiceSummary = () => {
            setLoading(true);
            return BillingService
                .GetInvoiceSummary(filters.from, filters.to, filters.billingCode, branch.code)
                .then(res => {
                    setInvoiceSummary(mapInvoiceSummaryItems(res));
                })
                .finally(() => setLoading(false))
        }

        if (!loading && branch.code)
            getInvoiceSummary();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filters, branch.code])

    return {
        invoiceSummary,
        filters,
        loading,
        pvs: [{ name: 'Todos', billingCode: 'all' }].concat(branch.pvs || []),
        setFilters,
    };
}

export default useInvoiceSummary;